import EventEmitter from "eventemitter3";
import { isDefined } from "../../shared/utils";
let segDrawpoint = {};
class GraphProc extends EventEmitter {
  constructor(paper, mag, edges, isOldPupilCornea) {
    super();
    this.paper = paper;
    this.currpath = undefined;
    this.currsegment = undefined;
    this.currentdrawcolor = undefined;
    this.moveGraph = false;
    this.mag = mag;
    this.mousedownpoint = undefined;
    this.curTearHeight = undefined;
    this.tearHeightScale = 1;
    this.ifauto = false;
    this.autoNum = undefined;
    this.isOldPupilCornea = isOldPupilCornea;
  }
  subpoint(p1, p2) {
    if (p1 === undefined || p2 === undefined) {
      return undefined;
    }
    return new this.paper.Point(p1.x - p2.x, p1.y - p2.y);
  }
  addpoint(p1, p2) {
    if (p1 === undefined || p2 === undefined) {
      return undefined;
    }
    return new this.paper.Point(p1.x + p2.x, p1.y + p2.y);
  }
  importMarking(marking) {
    this.paper.project.importJSON(marking);
    let txtitems = this.paper.project.getItems({
      class: this.paper.PointText
    });

    for (let i in txtitems) {
      if (txtitems[i].data.graphType !== "Text") {
        txtitems[i].remove();
      } else {
        let txtitem = txtitems[i];
        txtitem.onDoubleClick = () => {
          txtitem.remove();
          this.emit("updatetext", txtitem.position, txtitem.content, (updateTxt) => {
            this.drawTextContent(
              updateTxt,
              txtitem.position.x,
              txtitem.position.y,
              txtitem.fillColor
            );
          });
        };
      }
    }
    let pathitems = this.paper.project.getItems({
      class: this.paper.Path
    });

    for (let i in pathitems) {
      if (!pathitems[i].data || !pathitems[i].data.graphType) {
        switch (pathitems[i].segments.length) {
          case 2:
            pathitems[i].data = {
              graphType: "Line",
              graphUnit: "mm"
            };
            break;
          case 3:
            pathitems[i].data = {
              graphType: "Angle",
              graphUnit: "mm"
            };
            break;
          case 4:
            if (
              Math.abs(
                pathitems[i].segments[0].point.y === Math.abs(pathitems[i].segments[1].point.y)
              )
            ) {
              pathitems[i].data = {
                graphType: "Rect",
                graphUnit: "mm"
              };
            } else {
              pathitems[i].data = {
                graphType: "Circ",
                graphUnit: "mm"
              };
            }
            break;
          default:
            break;
        }
      }
      this.drawText(pathitems[i], false);
    }
  }
  drawTextAngle(path, remove) {
    if (path.segments.length === 3) {
      let paper = this.paper;
      let txt = new this.paper.PointText(path.position);
      var vec1 = new paper.Point(
        path.segments[1].point.x - path.segments[0].point.x,
        path.segments[1].point.y - path.segments[0].point.y
      );
      var vec2 = new paper.Point(
        path.segments[1].point.x - path.segments[2].point.x,
        path.segments[1].point.y - path.segments[2].point.y
      );
      var ang = vec1.angle - vec2.angle;
      if (ang < 0) ang = 0 - ang;
      if (ang > 180) ang = 360 - ang;
      vec1 = vec1.normalize(50);
      vec2 = vec2.normalize(50);
      var vec = new paper.Point(vec1.x + vec2.x, vec1.y + vec2.y);
      var pos = new paper.Point(path.segments[1].point.x - vec.x, path.segments[1].point.y - vec.y);
      txt = new paper.PointText(pos);
      txt.content = Math.round(ang) + "\xb0";
      txt.fillColor = path.strokeColor;
      txt.fontSize = "48px";
      if (remove) {
        txt.removeOnDrag();
      }
      path.text = txt;
      txt.parentpath = path;
    }
  }
  drawTextLine(path, coe, remove) {
    let txt = new this.paper.PointText(path.position);
    if (path.data.graphUnit === "mm") {
      txt.content = Math.floor(path.length * coe * 100) / 100 + "mm";
    } else if (path.data.graphUnit === "pix") {
      txt.content = parseInt(path.length) + "pix";
    } else {
      txt.content = "";
    }
    txt.fillColor = path.strokeColor;
    txt.fontSize = "48px";
    if (remove) {
      txt.removeOnDrag();
    }
    path.text = txt;
    txt.parentpath = path;
  }
  drawTextHeight(path, coe, remove) {
    let txt = new this.paper.PointText(path.position);

    if (path.data.graphUnit === "mm") {
      // txt.content = Math.floor(Math.abs(path.segments[2]._point.y - path.segments[3]._point.y) * coe * 100) / 100 + 'mm'
      // txt.content = (Math.floor((parseInt(path.length) - 240) * window.magecoe.tearheight / 600 * 2048 * 1000) / 1000).toFixed(2) + 'mm'
      // txt.content = (Math.floor((parseInt(path.length) - 240) * coe / 600 * 2048 * 1000) / 1000).toFixed(2) + 'mm'
      // 有争议的地方
      txt.content = ((path.length - 240) * this.mag * this.tearHeightScale).toFixed(2) + "mm";
    } else if (path.data.graphUnit === "pix") {
      // txt.content = parseInt(Math.abs(path.segments[2]._point.y - path.segments[3]._point.y)) + ' pix'
      // txt.content = (parseInt(path.length) - 240) + ' pix'
    } else {
      txt.content = "";
    }
    txt.fillColor = path.strokeColor;
    txt.fontSize = "48px";
    if (remove) {
      txt.removeOnDrag();
    }
    txt.position.x += 25;
    path.text = txt;
    txt.parentpath = path;
  }
  drawTextRect(path, coe, remove) {
    let txt = new this.paper.PointText(path.position);
    if (path.data.graphUnit === "mm") {
      txt.content = Math.floor(path.length * coe * 100) / 100 + "mm";
      txt.content += ` ${Math.floor(Math.abs(path.area) * coe * coe * 100) / 100} mm²`;
    } else if (path.data.graphUnit === "pix") {
      txt.content = "W: " + parseInt(path.strokeBounds.center._owner.width) + " pix";
      txt.content += " H: " + parseInt(path.strokeBounds.center._owner.height) + " pix";
    } else {
      txt.content = "";
    }
    txt.fillColor = path.strokeColor;
    txt.fontSize = "48px";
    if (remove) {
      txt.removeOnDrag();
    }
    path.text = txt;
    txt.parentpath = path;
  }
  drawTextOSD(content, x, y) {
    x = x || 70;
    y = y || 60;
    let txt = new this.paper.PointText(
      new this.paper.Point(x * this.drawScale, y * this.drawScale)
    );
    txt.content = content;
    txt.fillColor = new this.paper.Color(1.0, 1.0, 1.0, 1.0);
    txt.fontSize = `${this.fontSize}px`;
  }
  drawTextContent(content, x, y, color) {
    let txt = new this.paper.PointText(new this.paper.Point(x, y));
    txt.content = content;
    txt.fillColor = color;
    txt.fontSize = "48px";
    txt.data = {
      graphType: "Text"
    };
    txt.onDoubleClick = () => {
      txt.remove();
      let pos = txt.position;
      this.emit("updatetext", pos, txt.content, (updateTxt) => {
        this.drawTextContent(updateTxt, pos.x, pos.y, color);
      });
    };
  }
  drawText(path, remove) {
    if (path.text) {
      path.text.remove();
    }
    // if (defaultimageitem == undefined) return
    // var mag = (mag) || defaultimageitem.magval
    let coe = this.mag;
    // var measureMark = MeasureUnit.getMarkSetting()
    switch (path.data.graphType) {
      case "Line":
        this.drawTextLine(path, coe, remove);
        break;
      case "Height":
        this.drawTextHeight(path, coe, remove);
        break;
      case "Circ":
        this.drawTextRect(path, coe, remove);
        break;
      case "Rect":
        this.drawTextRect(path, coe, remove);
        break;
      case "Angle":
        this.drawTextAngle(path, remove);
        break;
      case "Meibomian":
        this.drawTextMeibomian(path, remove);
        break;
      default:
    }
  }
  drawTextMeibomian(path, remove) {
    if (path.segments.length === 3) {
    }
  }
  mouseUp(event, drawstatus) {
    if (this.currpath) {
      if (this.currpath.segments) {
        let minlength = this.currpath.data.graphType === "Circ" ? 20.0 : 10.0;
        // 画图尺寸过小,或者高度数值过小
        if (
          this.currpath.getOffsetOf(
            this.currpath.segments[this.currpath.segments.length - 1].point
          ) < minlength ||
          (this.currpath.data.graphType === "Height" &&
            Math.abs(this.currpath._segments[2].point.y - this.currpath._segments[3].point.y) < 1)
        ) {
          if (this.currpath.className !== "PointText" || this.currpath.parentpath === undefined) {
            if (this.currpath.text) {
              this.currpath.text.remove();
            }
            this.currpath.remove();
          }
          this.updateProject();
        } else if (this.currpath.data.graphType === "Meibomian" && drawstatus === "Meibomian") {
          this.currpath.simplify(3);
          let segments = this.currpath.segments;
          this.currpath = undefined;
          this.currsegment = undefined;
          this.eraserMeibomian();
          this.emit("update", this.paper.project.exportJSON(), segments);
        } else {
          if (this.currpath.data.graphType === "Angle" && this.currpath.segments.length === 2) {
            this.currpath.add(event.point);
          } else {
            this.updateProject();
          }
        }
      } else {
        this.updateProject();
      }
    } else {
      this.updateProject();
    }
  }

  updateProject() {
    this.moveGraph = false;
    this.currpath = undefined;
    this.currsegment = undefined;
    this.curTearHeight = this.calcTearHeightAvg();
    this.emit(
      "update",
      this.paper.project.exportJSON(),
      undefined,
      this.curTearHeight,
      this.ifauto
    );
  }
  eraserMeibomian() {
    let txtitems = this.paper.project.getItems({
      class: this.paper.PointText
    });
    if (txtitems[0] && txtitems[0].layer && txtitems[0].layer.children) {
      for (let id in txtitems[0].layer.children) {
        if (txtitems[0].layer.children[id]._segments && txtitems[0].layer.children.length > 2) {
          txtitems[0].layer.children.splice(id, 1);
          break;
        }
      }
    }
  }
  //  求泪河高度的平均值
  calcTearHeightAvg(autoTxt = null) {
    let count = 0;
    let avg = 0;
    let coe = this.mag;
    let contents = 0; // 当前你画的值多少mm
    let index;
    let array = [];
    let txtitems = this.paper.project.getItems({
      class: this.paper.PointText
    });
    let pathitems = this.paper.project.getItems({
      class: this.paper.Path
    });

    if (!pathitems.length === 1) {
      for (var i = 0; i < pathitems.length; i++) {
        if (pathitems[i].data.graphauto === "auto") {
          index = i;
          txtitems.splice(index, 1);
        }
      }
    }
    // 多少mm
    if (autoTxt) this.autoNum = autoTxt;
    let newAutoTxt =
      this.autoNum && this.autoNum.trensdDataYHeigth
        ? this.autoNum.trensdDataYHeigth
        : this.autoNum
          ? this.autoNum.clonetrensdDataYHeigth
          : null;
    newAutoTxt = newAutoTxt * this.mag;
    for (let id in txtitems) {
      // debugger
      if (
        txtitems[id]._content.indexOf("mm") >= 0 &&
        (pathitems[id] === undefined || pathitems[id].data.graphauto !== "auto")
      ) {
        contents = parseFloat(txtitems[id]._content.split("mm")[0]);
      }
      // if (txtitems[id]._content.indexOf('pix') >= 0) {
      //   contents = parseFloat(txtitems[id]._content.split('pix')[0]) * coe
      // }

      if (txtitems[id]._content === "OS" || txtitems[id]._content === "OD") {
      } else if (newAutoTxt && Number(newAutoTxt.toFixed(2)) === contents) {
      } else if (contents > 0) {
        count++;
        avg += contents;
        array.push(contents);
      }
    }
    avg = count === 0 ? -1000 : avg / count;
    let obj = {
      contents: contents,
      avg: avg,
      contents_array: array,
      clear: false
    };
    if (array.length === 0) {
      obj.clear = true;
    }

    return obj;
  }
  keyDown(event) {
    if (event.key === "shift") {
      return true;
    }
  }
  keyUp(event) {
    if (event.key === "shift") {
      return false;
    }
  }
  mouseDrag(event, drawstatus) {
    let paper = this.paper;
    // if (event.event.button !== 0 || (event.event.buttons !== 1 && event.event.buttons !== 0)) return
    if (
      event.point.x < 0 ||
      event.point.y < 0 ||
      event.point.x > paper.view.size.width ||
      event.point.y > paper.view.size.height
    )
      return;
    if (event.currentTarget._id !== paper.project.view.element.id) {
      return;
    }
    // --------------- Drag segment -----------------------
    if (this.currsegment) {
      switch (this.currsegment.path.data.graphType) {
        case "Line":
          this.currsegment.point = event.point;
          if (this.currsegment.path.text) {
            this.currsegment.path.text.remove();
          }
          this.drawText(this.currsegment.path, true);
          break;
        case "Height":
          if (this.currsegment._index <= 2) {
            let point1 = {};
            let point2 = {};
            point1.x = event.point.x;
            point1.y = event.point.y;
            point2.x = this.currsegment._path._segments[3].point.x;
            point2.y = this.currsegment._path._segments[3].point.y;
            let k = (point2.x - point1.x) / (point2.y - point1.y);
            this.currsegment._path._segments[0].point.x = point1.x - Math.cos(Math.atan(k)) * 40;
            this.currsegment._path._segments[0].point.y = point1.y + Math.sin(Math.atan(k)) * 40;
            this.currsegment._path._segments[1].point.x = point1.x + Math.cos(Math.atan(k)) * 40;
            this.currsegment._path._segments[1].point.y = point1.y - Math.sin(Math.atan(k)) * 40;
            this.currsegment._path._segments[2].point = event.point;
            this.currsegment._path._segments[4].point.x = point2.x - Math.cos(Math.atan(k)) * 40;
            this.currsegment._path._segments[4].point.y = point2.y + Math.sin(Math.atan(k)) * 40;
            this.currsegment._path._segments[5].point.x = point2.x + Math.cos(Math.atan(k)) * 40;
            this.currsegment._path._segments[5].point.y = point2.y - Math.sin(Math.atan(k)) * 40;
          } else {
            let point1 = {};
            let point2 = {};
            point1.x = this.currsegment._path._segments[2].point.x;
            point1.y = this.currsegment._path._segments[2].point.y;
            point2.x = event.point.x;
            point2.y = event.point.y;
            let k = (point2.x - point1.x) / (point2.y - point1.y);
            this.currsegment._path._segments[0].point.x = point1.x - Math.cos(Math.atan(k)) * 40;
            this.currsegment._path._segments[0].point.y = point1.y + Math.sin(Math.atan(k)) * 40;
            this.currsegment._path._segments[1].point.x = point1.x + Math.cos(Math.atan(k)) * 40;
            this.currsegment._path._segments[1].point.y = point1.y - Math.sin(Math.atan(k)) * 40;
            this.currsegment._path._segments[3].point = event.point;
            this.currsegment._path._segments[4].point.x = point2.x - Math.cos(Math.atan(k)) * 40;
            this.currsegment._path._segments[4].point.y = point2.y + Math.sin(Math.atan(k)) * 40;
            this.currsegment._path._segments[5].point.x = point2.x + Math.cos(Math.atan(k)) * 40;
            this.currsegment._path._segments[5].point.y = point2.y - Math.sin(Math.atan(k)) * 40;
          }
          this.drawText(this.currsegment.path, true);
          break;
        case "Angle":
          this.currsegment.point = event.point;
          if (this.currsegment.path.text) {
            this.currsegment.path.text.remove();
          }
          this.drawText(this.currsegment.path, true);
          break;
        case "Rect":
          if (this.currsegment.next.point.x === this.currsegment.point.x) {
            this.currsegment.next.point.x = this.currsegment.point.x = event.point.x;
            this.currsegment.previous.point.y = this.currsegment.point.y = event.point.y;
          } else {
            this.currsegment.previous.point.x = this.currsegment.point.x = event.point.x;
            this.currsegment.next.point.y = this.currsegment.point.y = event.point.y;
          }
          this.drawText(this.currsegment.path, true);
          break;
        case "pupildia":
          let circurrpath1 = this.currsegment.path;
          if (circurrpath1.data.fixed) return;
          this.removePupilEdge();
          let r1 = Math.sqrt(
            Math.pow(circurrpath1.data.center.x - segDrawpoint.x, 2) +
              Math.pow(circurrpath1.data.center.y - segDrawpoint.y, 2)
          );
          r1 = r1 > 800 ? 800 : r1;
          r1 = r1 < 10 ? 10 : r1;
          this.currpath = this.drawPupilEdge({
            x: circurrpath1.data.center.x,
            y: circurrpath1.data.center.y,
            r: r1
          });
          segDrawpoint.x += event.delta.x;
          segDrawpoint.y += event.delta.y;
          this.emit("edge-changed", "pupildia", {
            x: circurrpath1.data.center.x,
            y: circurrpath1.data.center.y,
            r: r1
          });

          break;
        case "corneadia":
          let circurrpath = this.currsegment.path;
          if (circurrpath.data.fixed) return;

          this.removeCorneaEdge();
          let r = Math.sqrt(
            Math.pow(circurrpath.data.center.x - segDrawpoint.x, 2) +
              Math.pow(circurrpath.data.center.y - segDrawpoint.y, 2)
          );
          r = r > 800 ? 800 : r;
          r = r < 10 ? 10 : r;
          this.currpath = this.drawCorneaEdge({
            x: circurrpath.data.center.x,
            y: circurrpath.data.center.y,
            r
          });
          segDrawpoint.x += event.delta.x;
          segDrawpoint.y += event.delta.y;
          this.emit("edge-changed", "corneadia", {
            x: circurrpath.data.center.x,
            y: circurrpath.data.center.y,
            r: r
          });
          break;
        case "Circ":
          let x1 = this.currsegment.point.x;
          let x2 = this.currsegment.point.x;
          let xp = this.currsegment.point.x;
          let y1 = this.currsegment.point.y;
          let y2 = this.currsegment.point.y;
          let yp = this.currsegment.point.y;
          let currpath = this.currsegment.path;
          for (var id in currpath.segments) {
            x1 = x1 > currpath.segments[id].point.x ? currpath.segments[id].point.x : x1;
            x2 = x2 < currpath.segments[id].point.x ? currpath.segments[id].point.x : x2;
            y1 = y1 > currpath.segments[id].point.y ? currpath.segments[id].point.y : y1;
            y2 = y2 < currpath.segments[id].point.y ? currpath.segments[id].point.y : y2;
          }
          if (x1 === xp) {
            x1 = event.point.x;
          } else if (x2 === xp) {
            x2 = event.point.x;
          } else if (y1 === yp) {
            y1 = event.point.y;
          } else if (y2 === yp) {
            y2 = event.point.y;
          }
          let rectangle = new paper.Rectangle(new paper.Point(x1, y1), new paper.Point(x2, y2));
          path = {};
          path = new paper.Path.Ellipse(rectangle);
          path.fillColor = currpath.fillColor;
          path.strokeColor = currpath.strokeColor || "0f0";
          path.strokeWidth = currpath.strokeWidth;
          path.closed = currpath.closed;
          path.data = {
            graphType: currpath.data.graphType,
            graphUnit: currpath.data.graphUnit
          };
          path.removeOnDrag();
          if (currpath.text) {
            currpath.text.remove();
          }
          currpath.remove();
          this.currpath = path;
          this.drawText(this.currpath, true);
          break;
        case "Meibomian":
          if (drawstatus === "Meibomian" && this.currpath.segments.length === 2) {
            this.currsegment.point = event.point;
            if (this.currsegment.path.text) {
              this.currsegment.path.text.remove();
            }
            this.drawText(this.currsegment.path, true);
          }
          break;
        default:
          break;
      }
      // --------------- Drag path -----------------------移动
    } else if (this.currpath && this.moveGraph) {
      if (
        (this.currpath.className !== "PointText" || this.currpath.parentpath === undefined) &&
        this.currpath.data.type !== "eyetype"
      ) {
        this.currpath.position.x += event.delta.x;
        this.currpath.position.y += event.delta.y;
        // 移动过就成为了手动测量
        if (this.currpath.data.graphauto === "auto") {
          this.currpath.data.graphauto = "";
        }
        if (this.currpath.data.graphType === "corneadia") {
          this.currpath.data.center.x += event.delta.x;
          this.currpath.data.center.y += event.delta.y;
          this.removeCorneaEdge();
          this.drawCorneaEdge({
            x: this.currpath.data.center.x,
            y: this.currpath.data.center.y,
            r: this.currpath.data.r
          });
          this.emit("edge-changed", "corneadia", {
            x: this.currpath.data.center.x,
            y: this.currpath.data.center.y,
            r: this.currpath.data.r
          });
        } else if (this.currpath.data.graphType === "corneadia") {
          this.currpath.data.center.x += event.delta.x;
          this.currpath.data.center.y += event.delta.y;
          this.emit("edge-changed", "corneadia", {
            x: this.currpath.data.center.x,
            y: this.currpath.data.center.y,
            r: this.currpath.data.r
          });
        } else if (this.currpath.data.graphType === "pupildia") {
          this.currpath.data.center.x += event.delta.x;
          this.currpath.data.center.y += event.delta.y;
          this.removePupilEdge();
          this.drawPupilEdge({
            x: this.currpath.data.center.x,
            y: this.currpath.data.center.y,
            r: this.currpath.data.r
          });
          this.emit("edge-changed", "pupildia", {
            x: this.currpath.data.center.x,
            y: this.currpath.data.center.y,
            r: this.currpath.data.r
          });
        } else if (this.currpath.data.graphType === "pupildia") {
          this.currpath.data.center.x += event.delta.x;
          this.currpath.data.center.y += event.delta.y;
          this.emit("edge-changed", "pupildia", {
            x: this.currpath.data.center.x,
            y: this.currpath.data.center.y,
            r: this.currpath.data.r
          });
        } else if (this.currpath.className !== "PointText") {
          this.drawText(this.currpath, true);
        }
        if (this.currpath.position.x < 0) {
          this.currpath.position.x = 0;
        }
        if (this.currpath.position.y < 0) {
          this.currpath.position.y = 0;
        }
        if (this.currpath.position.x > paper.view.size.width) {
          this.currpath.position.x = paper.view.size.width;
        }
        if (this.currpath.position.y > paper.view.size.height) {
          this.currpath.position.y = paper.view.size.height;
        }
      }
      // --------------- Drag path initial -----------------------
    } else if (this.currpath) {
      let path;
      switch (this.currpath.data.graphType) {
        case "Line":
          this.currpath.segments[1].point = event.point;
          this.drawText(this.currpath, true);
          break;
        case "Height":
          let point1 = {};
          let point2 = {};
          point1.x = this.currpath.segments[2].point.x;
          point1.y = this.currpath.segments[2].point.y;
          point2.x = event.point.x;
          point2.y = event.point.y;
          let k = (point2.x - point1.x) / (point2.y - point1.y);
          this.currpath.segments[0].point.x = point1.x - Math.cos(Math.atan(k)) * 40;
          this.currpath.segments[0].point.y = point1.y + Math.sin(Math.atan(k)) * 40;
          this.currpath.segments[1].point.x = point1.x + Math.cos(Math.atan(k)) * 40;
          this.currpath.segments[1].point.y = point1.y - Math.sin(Math.atan(k)) * 40;
          this.currpath.segments[3].point = event.point;
          this.currpath.segments[4].point.x = point2.x - Math.cos(Math.atan(k)) * 40;
          this.currpath.segments[4].point.y = point2.y + Math.sin(Math.atan(k)) * 40;
          this.currpath.segments[5].point.x = point2.x + Math.cos(Math.atan(k)) * 40;
          this.currpath.segments[5].point.y = point2.y - Math.sin(Math.atan(k)) * 40;
          this.drawText(this.currpath, true);
          break;
        case "Rect":
          this.currpath.segments[1].point.x = event.point.x;
          this.currpath.segments[2].point = event.point;
          this.currpath.segments[3].point.y = event.point.y;
          this.drawText(this.currpath, true);
          break;

        case "Circ":
          let pt = event.point;
          let rectangle = new paper.Rectangle(this.mousedownpoint, pt);
          path = new paper.Path.Ellipse(rectangle);
          path.fillColor = this.currpath.fillColor;
          path.strokeColor = this.currpath.strokeColor || "0f0";
          path.strokeWidth = this.currpath.strokeWidth;
          path.closed = this.currpath.closed;
          path.data = {
            graphType: this.currpath.data.graphType,
            graphUnit: this.currpath.data.graphUnit
          };
          path.removeOnDrag();
          this.currpath = path;
          this.drawText(this.currpath, true);
          break;
        case "Angle":
          if (this.currpath.segments.length === 2) {
            this.currpath.segments[1].point = event.point;
            this.drawText(this.currpath, true);
          }
          break;
        case "Vector":
          this.currpath.segments[1].point = event.point;
          let arrowVector = this.subpoint(event.point, this.currpath.segments[0].point).normalize(
            10
          );
          var path1 = new paper.Path(
            this.addpoint(event.point, arrowVector.rotate(135)),
            event.point,
            this.addpoint(event.point, arrowVector.rotate(-135))
          );
          path = new paper.Path(this.currpath.segments[0].point, event.point);
          path.fillColor = this.currpath.fillColor;
          path.strokeColor = this.currpath.strokeColor || "0f0";
          path.strokeWidth = this.currpath.strokeWidth;
          path.closed = this.currpath.closed;
          path.data = {
            graphType: this.currpath.data.graphType,
            graphUnit: this.currpath.data.graphUnit
          };
          path.join(path1);
          path.removeOnDrag();
          path1.removeOnDrag();
          break;
        case "Meibomian":
          if (drawstatus === "Meibomian") {
            this.currpath.add(event.point);
          }
          break;
        default:
          break;
      }
    } else {
    }
  }
  DoubleClick(event) {
    if (this.currpath) {
      if (this.currpath.data.graphType === "Meibomian") {
        let segments = this.currpath.segments;
        this.currpath = undefined;
        this.currsegment = undefined;
        this.emit("update", this.paper.project.exportJSON(), segments);
      }
    }
  }
  mouseDown(event, drawstatus, drawcolor, drawunit) {
    let paper = this.paper;
    segDrawpoint.x = event.point.x;
    segDrawpoint.y = event.point.y;
    // if (event.event.button !== 0 || (event.event.buttons !== 1 && event.event.buttons !== 0)) return
    if (event.currentTarget._id !== paper.project.view.element.id) {
      return;
    }
    if (this.currpath) {
      if (this.currpath.data.graphType === "Angle" && this.currpath.complete === false) {
        this.currpath.complete = true;
        this.currpath = undefined;
        this.currsegment = undefined;
        return;
      }
    }
    let hitResult = paper.project.hitTest(event.point, {
      segments: true,
      stroke: true,
      fill: true,
      tolerance: 5
    });

    if (
      hitResult &&
      hitResult.item &&
      (hitResult.item.name === "pupildia" || hitResult.item.name === "corneadia") &&
      !this.isOldPupilCornea
    ) {
      return;
    }
    if (hitResult) {
      this.emit("drag", true);
    } else {
      this.emit("drag", false);
    }
    if (hitResult && hitResult.type) {
      switch (hitResult.type) {
        case "segment":
          this.currsegment = hitResult.segment;
          return;
        case "fill":
        case "stroke":
          if (drawstatus === "Eraser") {
            // 删除标记
            if (
              hitResult.item.className !== "PointText" ||
              hitResult.item.parentpath === undefined
            ) {
              if (hitResult.item.data.graphauto === "auto") {
                this.ifauto = true;
              }
              if (hitResult.item.text) {
                hitResult.item.text.remove();
              }
              hitResult.item.remove();
            }
          } else {
            this.currpath = hitResult.item;
            hitResult.item.bringToFront();
            this.moveGraph = true;
          }
          return;
        default:
          break;
      }
    }
    let path = {};
    switch (drawstatus) {
      case "Select":
        this.currpath = undefined;
        break;
      case "Line":
        path = new paper.Path(event.point, new paper.Point(event.point.x, event.point.y));
        path.strokeColor = drawcolor;
        path.strokeWidth = 4;
        path.data = {
          graphType: "Line",
          graphUnit: drawunit
        };
        this.currpath = path;
        break;
      case "Height":
        let obj = this.calcTearHeightAvg();
        if (obj.contents_array.length < 20) {
          let heightPoint1 = new paper.Point(event.point.x, event.point.y);
          let heightPoint2 = new paper.Point(event.point.x, event.point.y + 1.0);
          path = new paper.Path(
            [heightPoint1.x - 40, heightPoint1.y],
            [heightPoint1.x + 40, heightPoint1.y]
          );
          path.add(heightPoint1);
          path.add(heightPoint2);
          path.add(heightPoint2.x - 40, heightPoint2.y);
          path.add(heightPoint2.x + 40, heightPoint2.y);
          path.strokeColor = drawcolor;
          path.strokeWidth = 2;
          path.data = {
            graphType: "Height",
            graphUnit: drawunit
          };
          this.currpath = path;
        }
        break;
      case "Rect":
        let p2 = new paper.Point(event.point.x + 1.0, event.point.y);
        let p3 = new paper.Point(event.point.x + 1.0, event.point.y + 1.0);
        let p4 = new paper.Point(event.point.x, event.point.y + 1.0);
        path = new paper.Path([event.point, p2, p3, p4]);
        path.strokeColor = drawcolor;
        path.strokeWidth = 4;
        path.fillColor = new paper.Color(1.0, 1.0, 1.0, 0.01);
        path.closed = true;
        path.data = {
          graphType: "Rect",
          graphUnit: drawunit
        };
        this.currpath = path;
        break;
      case "Circ":
        let rectangle = new paper.Rectangle(event.point, new paper.Size(1, 1));
        path = new paper.Path.Ellipse(rectangle);
        path.strokeColor = drawcolor;
        path.fillColor = new paper.Color(1.0, 1.0, 1.0, 0.01);
        path.strokeWidth = 4;
        path.removeOnDrag();
        path.data = {
          graphType: "Circ",
          graphUnit: drawunit
        };
        this.mousedownpoint = event.point;
        this.currpath = path;
        break;
      case "Vector":
        path = new paper.Path(event.point, new paper.Point(event.point.x, event.point.y));
        path.strokeColor = drawcolor;
        path.strokeWidth = 4;
        path.data = {
          graphType: "Vector",
          graphUnit: drawunit
        };
        path.removeOnDrag();
        this.currpath = path;
        break;
      case "Angle":
        path = new paper.Path(event.point, new paper.Point(event.point.x + 1.0, event.point.y));
        path.strokeColor = drawcolor;
        path.strokeWidth = 4;
        path.data = {
          graphType: "Angle",
          graphUnit: drawunit
        };
        path.complete = false;
        this.currpath = path;
        break;
      case "Text":
        this.emit("waitinput", event.point, (txt) => {
          this.drawTextContent(txt, event.point.x, event.point.y, drawcolor);
        });
        break;
      case "Meibomian":
        path = new paper.Path(event.point, new paper.Point(event.point.x + 1.0, event.point.y));
        path.strokeColor = drawcolor;
        path.strokeWidth = 4;
        path.fullySelected = true;
        path.data = {
          graphType: "Meibomian",
          graphUnit: drawunit
        };
        this.currpath = path;
        break;
      default:
        break;
    }
  }
  mouseMove(event) {
    let paper = this.paper;
    if (paper.project) {
      if (paper.project.view.element.id !== event.currentTarget._id) {
        for (var pid in paper.projects) {
          if (paper.projects[pid].view.element.id === event.currentTarget._id) {
            paper.projects[pid].activate();
          }
        }
      }
      let hitResult;
      if (paper.project.hitTest) {
        hitResult = paper.project.hitTest(event.point, {
          segments: true,
          stroke: true,
          fill: true,
          tolerance: 5
        });
      }
      if (paper.project.activeLayer) {
        paper.project.activeLayer.selected = false;
      }
      if (
        hitResult &&
        hitResult.item &&
        (hitResult.item.className !== "PointText" || hitResult.item.parentpath === undefined) &&
        hitResult.item.data.type !== "eyetype"
      ) {
        hitResult.item.selected = true;
      }
    }
    if (this.currpath) {
      if (this.currpath.data.graphType === "Angle" && !this.currpath.complete) {
        this.currpath.segments[2].point = event.point;
        this.drawText(this.currpath, true);
      }
    }
    // document.body.style.cursor = 'pointer'
  }
  getPupilEdge() {
    return this.paper.project.getItems({
      name: "pupildia"
    });
  }
  getCorneaEdge() {
    return this.paper.project.getItems({
      name: "corneadia"
    });
  }
  removeCorneaEdge() {
    let edges = this.getCorneaEdge();
    for (let id in edges) {
      if (edges[id]) {
        edges[id].remove();
      }
    }
  }
  removePupilEdge() {
    let edges = this.getPupilEdge();
    for (let id in edges) {
      if (edges[id]) {
        edges[id].remove();
      }
    }
  }

  drawPupilLine(paper, pt) {
    let start = 0;
    let end = 0;
    let path1 = new paper.Path.Line({
      from: [pt.rx - start - 10, pt.ry],
      to: [pt.rx + end + 10, pt.ry],
      strokeColor: "#fff",
      strokeWidth: 3
    });
    path1.name = "pupildia";
    let path2 = new paper.Path.Line({
      from: [pt.rx, pt.ry - start - 10],
      to: [pt.rx, pt.ry + end + 10],
      strokeColor: "#fff",
      strokeWidth: 3
    });
    path2.name = "pupildia";
    start = -10;
    end = -10;
    let path;
    for (let i = 0; i < 3; i++) {
      start += 20 * 2;
      end += 20 * 2;
      // 绘制横虚线
      path = new paper.Path.Line({
        from: [pt.rx - start, pt.ry],
        to: [pt.rx - start - 20, pt.ry],
        strokeColor: "#fff",
        strokeWidth: 3
      });
      path.name = "pupildia";
      path = new paper.Path.Line({
        from: [pt.rx + end, pt.ry],
        to: [pt.rx + end + 20, pt.ry],
        strokeColor: "#fff",
        strokeWidth: 3
      });
      path.name = "pupildia";

      // 绘制竖虚线
      path = new paper.Path.Line({
        from: [pt.rx, pt.ry - start],
        to: [pt.rx, pt.ry - start - 20],
        strokeColor: "#fff",
        strokeWidth: 3
      });
      path.name = "pupildia";
      path = new paper.Path.Line({
        from: [pt.rx, pt.ry + end],
        to: [pt.rx, pt.ry + end + 20],
        strokeColor: "#fff",
        strokeWidth: 3
      });
      path.name = "pupildia";
    }
  }
  // 瞳孔直径
  drawPupilEdge(edge) {
    if (!isDefined(edge) && !isDefined(edge.r) && edge.r <= 0) return;
    let pt = edge;
    let paper = this.paper;

    this.removePupilEdgeByVedio();

    let path = new paper.Path.Circle(new paper.Point(pt.x, pt.y), pt.r);
    path.strokeColor = "#0f0";
    path.strokeWidth = 4;
    path.dashArray = [24, 8];
    path.name = "pupildia";
    path.data = {
      graphType: "pupildia",
      graphUnit: "mm",
      center: { x: pt.x, y: pt.y },
      r: pt.r
    };
    this.drawPupilLine(paper, pt);

    let path1 = new paper.Path.Line({
      from: [pt.x - 20, pt.y],
      to: [pt.x + 20, pt.y],
      strokeColor: "#0f0",
      strokeWidth: 4
    });
    path1.dashArray = [10, 4];
    path1.name = "pupildia";
    path1.data = {
      fixed: true,
      graphType: "pupildia",
      graphUnit: "mm",
      center: { x: pt.x, y: pt.y },
      r: pt.r
    };
    let path2 = new paper.Path.Line({
      from: [pt.x, pt.y - 20],
      to: [pt.x, pt.y + 20],
      strokeColor: "#0f0",
      strokeWidth: 4
    });
    path2.dashArray = [10, 4];
    path2.name = "pupildia";
    path2.data = {
      fixed: true,
      graphType: "pupildia",
      graphUnit: "mm",
      center: { x: pt.x, y: pt.y },
      r: pt.r
    };
    this.currpath = path;
  }

  removePupilEdgeByVedio() {
    let paper = this.paper;
    paper.project.activeLayer.children.forEach((item) => {
      if (item.name === "pupildia") {
        item.remove();
      }
    });

    paper.project.activeLayer.children.forEach((item) => {
      if (item.name === "pupildia1") {
        item.remove();
      }
    });

    paper.project.activeLayer.children.forEach((item) => {
      if (item.name === "pupildia2") {
        item.remove();
      }
    });

    paper.project.activeLayer.children.forEach((item) => {
      if (item.name === "pupildia3") {
        item.remove();
      }
    });

    paper.project.activeLayer.children.forEach((item) => {
      if (item.name === "pupildia4") {
        item.remove();
      }
    });
  }

  drawPupilEdgeByVedio(edge) {
    if (!isDefined(edge) && !isDefined(edge.r) && edge.r <= 0) return;
    let pt = edge;
    let paper = this.paper;

    this.removePupilEdgeByVedio();

    let path = new paper.Path.Circle(new paper.Point(pt.x, pt.y), pt.r);
    path.strokeColor = "#0f0";
    path.strokeWidth = 2;
    path.dashArray = [6, 3];
    path.name = "pupildia";
    path.data = {
      graphType: "pupildia",
      graphUnit: "mm",
      center: { x: pt.x, y: pt.y },
      r: pt.r
    };
    let path3 = new paper.Path.Line({
      from: [pt.rx - pt.r + 10, pt.ry],
      to: [pt.rx + pt.r - 10, pt.ry],
      strokeColor: "#fff",
      strokeWidth: 1
    });
    path3.dashArray = [10, 5];
    path3.name = "pupildia3";
    path3.data = {
      fixed: true,
      graphType: "pupildia3",
      graphUnit: "mm",
      center: { x: pt.rx, y: pt.ry },
      r: pt.r
    };

    let path4 = new paper.Path.Line({
      from: [pt.rx, pt.ry - pt.r + 10],
      to: [pt.rx, pt.ry + pt.r - 10],
      strokeColor: "#fff",
      strokeWidth: 1
    });
    path4.dashArray = [10, 5];
    path4.name = "pupildia4";
    path4.data = {
      fixed: true,
      graphType: "pupildia4",
      graphUnit: "mm",
      center: { x: pt.rx, y: pt.ry },
      r: pt.r
    };

    let path1 = new paper.Path.Line({
      from: [pt.x - 5, pt.y],
      to: [pt.x + 5, pt.y],
      strokeColor: "#0f0",
      strokeWidth: 1.5
    });
    path1.dashArray = [5, 1];
    path1.name = "pupildia1";
    path1.data = {
      fixed: true,
      graphType: "pupildia1",
      graphUnit: "mm",
      center: { x: pt.x, y: pt.y },
      r: pt.r
    };

    let path2 = new paper.Path.Line({
      from: [pt.x, pt.y - 5],
      to: [pt.x, pt.y + 5],
      strokeColor: "#0f0",
      strokeWidth: 1.5
    });
    path2.dashArray = [5, 1];
    path2.name = "pupildia2";
    path2.data = {
      fixed: true,
      graphType: "pupildia2",
      graphUnit: "mm",
      center: { x: pt.x, y: pt.y },
      r: pt.r
    };

    this.currpath = path;
  }
  // 角膜直径
  drawCorneaEdge(edge) {
    if (!isDefined(edge) && !isDefined(edge.r) && edge.r <= 0) return;
    let pt = edge;
    let paper = this.paper;
    this.drawPupilLine(paper, pt);
    let arc1 = {
      from: [
        pt.x + pt.r * Math.cos((20 / 180.0) * Math.PI),
        pt.y + pt.r * Math.sin((20 / 180.0) * Math.PI)
      ],
      through: [pt.x + pt.r, pt.y],
      to: [
        pt.x + pt.r * Math.cos((20 / 180.0) * Math.PI),
        pt.y + -pt.r * Math.sin((20 / 180.0) * Math.PI)
      ]
    };
    let path = new paper.Path.Arc(arc1);
    // segDrawpoint = event
    // path.fillColor = '#0f0'
    path.strokeColor = "yellow";
    path.strokeWidth = 4;
    path.dashArray = [10, 4];
    path.name = "corneadia";
    path.data = {
      graphType: "corneadia",
      graphUnit: "mm",
      center: { x: pt.x, y: pt.y },
      r: pt.r
    };
    // path.removeOnDrag()
    let arc2 = {
      from: [
        pt.x - pt.r * Math.cos((20 / 180.0) * Math.PI),
        pt.y + pt.r * Math.sin((20 / 180.0) * Math.PI)
      ],
      through: [pt.x - pt.r, pt.y],
      to: [
        pt.x - pt.r * Math.cos((20 / 180.0) * Math.PI),
        pt.y + -pt.r * Math.sin((20 / 180.0) * Math.PI)
      ]
    };
    let path3 = new paper.Path.Arc(arc2);
    path3.strokeColor = "yellow";
    path3.strokeWidth = 4;
    path3.dashArray = [10, 4];
    path3.name = "corneadia";
    path3.data = {
      graphType: "corneadia",
      graphUnit: "mm",
      center: { x: pt.x, y: pt.y },
      r: pt.r
    };
    // path3.removeOnDrag()
    let path1 = new paper.Path.Line({
      from: [pt.x - 20, pt.y],
      to: [pt.x + 20, pt.y],
      strokeColor: "yellow",
      strokeWidth: 3
    });
    path1.dashArray = [10, 4];
    path1.name = "corneadia";
    path1.data = {
      fixed: true,
      graphType: "corneadia",
      graphUnit: "mm",
      center: { x: pt.x, y: pt.y },
      r: pt.r
    };
    let path2 = new paper.Path.Line({
      from: [pt.x, pt.y - 20],
      to: [pt.x, pt.y + 20],
      strokeColor: "yellow",
      strokeWidth: 3
    });
    path2.dashArray = [10, 4];
    path2.name = "corneadia";
    path2.data = {
      fixed: true,
      graphType: "corneadia",
      graphUnit: "mm",
      center: { x: pt.x, y: pt.y },
      r: pt.r
    };
    this.currpath = path;
    return path;
  }
  // 工字型标记
  drawHeight(event, drawstatus, curHeight, drawcolor, drawunit, scale) {
    this.tearHeightScale = scale;
    if (drawstatus === "Select" || drawstatus === "AutoHeight") {
      let paper = this.paper;
      let path = {};
      let point0 = {};
      let point1 = {};
      let point4 = {};
      let point5 = {};
      let heightPoint1 = new paper.Point(event.pointup.x, event.pointup.y); //  等同于point2
      let heightPoint2 = new paper.Point(event.pointdown.x, event.pointdown.y); // 等同于point3
      let k = (heightPoint2.x - heightPoint1.x) / (heightPoint2.y - heightPoint1.y);
      point0.x = heightPoint1.x - Math.cos(Math.atan(k)) * 40;
      point0.y = heightPoint1.y + Math.sin(Math.atan(k)) * 40;
      point1.x = heightPoint1.x + Math.cos(Math.atan(k)) * 40;
      point1.y = heightPoint1.y - Math.sin(Math.atan(k)) * 40;
      point4.x = heightPoint2.x - Math.cos(Math.atan(k)) * 40;
      point4.y = heightPoint2.y + Math.sin(Math.atan(k)) * 40;
      point5.x = heightPoint2.x + Math.cos(Math.atan(k)) * 40;
      point5.y = heightPoint2.y - Math.sin(Math.atan(k)) * 40;
      path = new paper.Path([point0.x, point0.y], [point1.x, point1.y]);
      path.add(heightPoint1);
      path.add(heightPoint2);
      path.add(point4.x, point4.y);
      path.add(point5.x, point5.y);
      path.strokeColor = "#0f0";
      path.strokeWidth = 2;
      path.data = {
        graphType: "Height",
        graphUnit: drawunit,
        graphauto: drawstatus === "AutoHeight" ? "" : "auto"
      };
      this.currpath = path;
      this.curTearHeight = curHeight = Math.floor(curHeight) / 100;
      this.drawText(this.currpath, true);
      this.updateProject();
    }
  }
}
export default GraphProc;



// WEBPACK FOOTER //
// ./src/common/js/graphics.js